import { http as axios } from "@/general/utils/http";
import { Company, UserInfo } from "@/general/store/models";
import { AxiosResponse } from "axios";

/**
 * Export class Authentication Api
 */
export default class AuthApi {
  /**
   * Retrieve user information
   *
   * @param {string} companyCd Company code
   * @returns {object} user infomation object
   */
  public static async getUserInfoRead(companyCd: string): Promise<UserInfo> {
    return await axios.get("/api/userinfo_read?companyCd=" + companyCd);
  }

  /**
   * Get company list information
   *
   * @returns {Array}
   */
  static getUserInfoCompanyList(): Promise<Company[]> {
    return axios.get(`/api/userinfo_company_list`);
  }

  /**
   * Update last login information
   * @returns {String} status message.
   */
  static async putLastLoginUpdate(userId: string | number) {
    const postData = {
      userId: userId
    };
    console.log(userId);
    console.log({postData});
    return await axios.post("/api/lastlogin_update", postData);
  }

  public static async getICSession(): Promise<string> {
    const response_data: AxiosResponse<any> = await axios.get(
      `/v1/ic-session/get`
    );
    return JSON.stringify(response_data);
  }

  public static getUserContractInfo(): Promise<any> {
    return axios.post("/v1/users/contract-info");
  }

  public static updateUser(params: any): Promise<any>{
    return axios.put("/v1/users/member-info", params);
  }

  public static postUser(): Promise<any>{
    return axios.post("/v1/users/my");
  }

  public static postSession(params: any) {
    const resource_session = "/v1/shop/session";
    return axios.post(`${resource_session}`, params);
  }
  /**
   * 初回ログイン完了
   */
  public static putComplete(params: any): Promise<any>{
    const resource_complete = "/v1/shop/complete_first_login";
    return axios.put(`${resource_complete}`, params);
  }
  /**
   * ログアウト
   */
  public static getLogout() {
    const resource_logout = "/v1/top/logout";
    return axios.get(`${resource_logout}`);
  }

  // グループの取得
  static async getSelectLoginGroup(bsCustomerNumber: any): Promise<any> {
    return await axios.get(`api/select_login_group`, {
      params: {
        bsCustomerNumber: bsCustomerNumber
    }})
  }

  // モード選択画面の表示有無
  static async getModeSelect(bsCustomerNumber: any, groupId: any): Promise<any> {
    return await axios.get(`api/mode_select`, {
      params: {
        bsCustomerNumber: bsCustomerNumber,
        groupId: groupId
    }})
  }

  // groupBudgetuserのissとsubを取得
  static async getGroupBudgetUserInfo(groupId: any): Promise<any> {
    return await axios.get(`api/groupbudgetuserinfo`, {
      params: {
        groupId: groupId
      }
    })
  }
  /**
   * BsffSession取得
   */
  public static getBsffSessionInfo() {
    const resource_bsff_session_info = "/v1/users/bsff-auth-sessionInfo";
    return axios.get(`${resource_bsff_session_info}`);
  }
}
